(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-ticker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rs-ticker__toggle');
    if (!button) return;
    const ticker = button.closest('.rs-ticker');
    const paused = ticker.classList.toggle('rs-ticker--paused');
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      paused ? 'Relancer le défilement des annonces' : 'Mettre en pause le défilement des annonces'
    );
  });

  } catch(e) { console.error(e); }
})();
})();
